import React from 'react'

const campanhasRoutes = [

    {
        path: '/campanhas',
        exact: true,
        component: React.lazy(() => import('./cadastros/lista/Table')),
    },

    {
        path: '/campanhas/novo',
        exact: true,
        component: React.lazy(() => import('./cadastros/form/Form')),
    },

]

export default campanhasRoutes
